import {
    createStandardAction,
} from "typesafe-actions";
import { ITrack } from "../api";

export const addUploads = createStandardAction('ADD_UPLOADS')<File[]>();

interface IUploadMeta {
    id: string,
}
  
export const doUploadRequest = createStandardAction('DO_UPLOAD_REQUEST')<void, IUploadMeta>();
export const doUploadSuccess = createStandardAction('DO_UPLOAD_SUCCESS')<ITrack, IUploadMeta>();
export const doUploadFailure = createStandardAction('DO_UPLOAD_FAILURE')<Error, IUploadMeta>();



// WEBPACK FOOTER //
// ./src/actions/uploadActions.ts